module.exports = __webpack_public_path__ + "img/logo_dark_bg_full@2x.dd5cd8d0.png";